import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { assignHeader, individualLeaveGroupDetails } from "pages/HR/Headers";
import { IndividualLeaveGroupMove } from "./IndividualLeaveGroupMove";
import { tableRowSx, tableHeaderSx } from "services/constants";
import { MoveUp } from "@mui/icons-material";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import comLogo from "../../../../../assets/img/brand/company_logo.png";
import Checkbox from "@mui/material/Checkbox";
import { tableData } from "services/constants/Styles";
import { themes, optionalAvathar } from "services/constants";
import { CustomButton } from "components/CustomComponents";
import { customGetAPI } from "services/utils/CustomAPI";
import { Loader } from "components/Loader";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const keys = [
  "employee_id",
  "user_name",
  "leave_group_name",
  "company_name",
  "effective_from",
  "effective_to",
];

export const ListView = ({
  masterDataUserDetails,
  loading,
  setFetchUserDetails,
  manualLeaveCredit,
  leaveGroupName,
  showFilter,
  setShowCreditDetils,
  selectedArray,
  setSelectedArray,
  setExpendRowId,
  expendRowId,
  statusName,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [individualPersonMove, setIndividualPersonMove] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [individualPersonMoveDetails, setIndividualPersonMoveDetails] =
    useState({});
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [advanceSalaryData, setAdvanceSalaryData] = useState(
    masterDataUserDetails
  );

  const [expandItem, setExpandItem] = useState([]);
  const [expandDetails, setExapandDetils] = useState([]);
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [triggerApi, setTriggerApi] = useState(false);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const containerRef = useRef(null);
  const [individualLoader, setIndividualLoader] = useState(false);
  const [tableHeight, setTableHeight] = useState(
    window.innerHeight < 700
      ? window.innerHeight * 0.65
      : window.innerHeight * 0.75
  );

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [page]);

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerHeight < 700) {
        setTableHeight(window.innerHeight * 0.65);
      } else {
        setTableHeight(window.innerHeight * 0.75);
      }
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedArray(advanceSalaryData);
    } else {
      setSelectedArray([]);
    }
    setSelectAll(event.target.checked);
  };

  const handleCheckboxChange = (event, item) => {
    let updatedSelection;
    if (event.target.checked) {
      updatedSelection = [...selectedArray, item];
    } else {
      updatedSelection = selectedArray.filter((i) => i.id !== item.id);
    }
    setSelectedArray(updatedSelection);
    setSelectAll(updatedSelection.length === advanceSalaryData?.length);
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      setIndividualLoader(true);
      const res = await customGetAPI(
        `${domain}user-leave-balance/?leavegroup_id=${expandItem?.leave_group_id}&user_id=${expandItem?.user_id}`
      );
      if (res.ok) {
        setExapandDetils(res?.responseDetails);
        setTriggerApi(false);
        setIndividualLoader(false);
      } else {
        setTriggerApi(false);
        setIndividualLoader(false);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
    }
  }, [domain, expandItem?.leave_group_id, expandItem?.user_id, triggerApi]);

  useEffect(() => {
    const filteredResults = masterDataUserDetails?.filter((item) =>
      keys.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setAdvanceSalaryData(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterDataUserDetails, page]);

  return loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{
            mt: 2,
            width: "100%",
            paddingLeft: 2,
            maxHeight: tableHeight,
            ml: 2,
            mr: 2,
          }}
        >
          <Mui.Table className="border">
            <Mui.TableHead sx={tableHeaderSx}>
              <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                {assignHeader.map((head) => (
                  <Mui.TableCell sx={tableData}>
                    {head.key === "check_box" &&
                    manualLeaveCredit &&
                    statusName !== "Inactive" ? (
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        size="medium"
                        disabled={
                          leaveGroupName?.name === "All Leave Group" ||
                          leaveGroupName === "All Leave Group"
                        }
                      />
                    ) : statusName === "Inactive" && head.name !== "Action" ? (
                      head.name
                    ) : statusName !== "Inactive" ? (
                      head.name
                    ) : null}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {advanceSalaryData?.length === 0 && !loading ? (
                <InfoMessage dataLength={masterDataUserDetails} />
              ) : (
                advanceSalaryData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <>
                      <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                        {assignHeader.map((head) =>
                          head.name === "Action" &&
                          statusName !== "Inactive" ? (
                            <Mui.TableCell>
                              {item?.effective_from && item?.effective_to ? (
                                <Mui.Tooltip
                                  arrow
                                  slotProps={tooltipStyleProps}
                                  title="User is not currently assigned to this leave group."
                                >
                                  <span>
                                    <Mui.IconButton disabled>
                                      <MoveUp />
                                    </Mui.IconButton>
                                  </span>
                                </Mui.Tooltip>
                              ) : (
                                <Mui.IconButton
                                  onClick={() => {
                                    if (
                                      checkEditorPermission(
                                        userScreenAccess?.module_details,
                                        "LMS",
                                        "Assignment"
                                      )
                                    ) {
                                      setIndividualPersonMoveDetails(item);
                                      setIndividualPersonMove(true);
                                    } else {
                                      showToast(
                                        "error",
                                        "Access denied: You are not authorized to allow move the user"
                                      );
                                    }
                                  }}
                                >
                                  <MoveUp />
                                </Mui.IconButton>
                              )}
                            </Mui.TableCell>
                          ) : head.key === "arrow_down" &&
                            statusName !== "Inactive" ? (
                            <Mui.TableCell>
                              {item?.effective_from && item?.effective_to ? (
                                <Mui.Tooltip
                                  arrow
                                  slotProps={tooltipStyleProps}
                                  title="User is not currently assigned to this leave group."
                                >
                                  <span>
                                    <Mui.IconButton disabled>
                                      <KeyboardArrowRight />
                                    </Mui.IconButton>
                                  </span>
                                </Mui.Tooltip>
                              ) : expendRowId === item.id ? (
                                <Mui.IconButton
                                  onClick={() => setExpendRowId(0)}
                                >
                                  <KeyboardArrowDown />
                                </Mui.IconButton>
                              ) : (
                                <Mui.IconButton
                                  onClick={() => {
                                    setExapandDetils([]);
                                    setExpendRowId(item.id);
                                    setExpandItem(item);
                                    setTriggerApi(true);
                                  }}
                                >
                                  <KeyboardArrowRight />
                                </Mui.IconButton>
                              )}
                            </Mui.TableCell>
                          ) : head.key === "check_box" &&
                            manualLeaveCredit &&
                            statusName !== "Inactive" ? (
                            <Mui.TableCell>
                              {item?.effective_from && item?.effective_to ? (
                                <Mui.Tooltip
                                  arrow
                                  slotProps={tooltipStyleProps}
                                  title="User is not currently assigned to this leave group."
                                >
                                  <span>
                                    <Checkbox disabled />
                                  </span>
                                </Mui.Tooltip>
                              ) : (
                                <Checkbox
                                  checked={selectedArray.some(
                                    (i) => i.id === item.id
                                  )}
                                  onChange={(event) => {
                                    if (
                                      checkEditorPermission(
                                        userScreenAccess?.module_details,
                                        "LMS",
                                        "Assignment"
                                      )
                                    ) {
                                      handleCheckboxChange(event, item);
                                    } else {
                                      showToast(
                                        "error",
                                        "Access denied: You are not authorized to allow manual leave credit to this user"
                                      );
                                    }
                                  }}
                                  disabled={
                                    !showFilter
                                      ? selectedArray.length > 0 &&
                                        selectedArray[0].leave_group_name !==
                                          item.leave_group_name
                                      : leaveGroupName?.name ===
                                          "All Leave Group" ||
                                        leaveGroupName === "All Leave Group"
                                  }
                                />
                              )}
                            </Mui.TableCell>
                          ) : (
                            <Mui.TableCell>
                              {head.key === "user_name" ? (
                                <Mui.Stack direction="Row">
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={item?.user_name
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={item?.image_url ?? optionalAvathar}
                                  />{" "}
                                  &nbsp;
                                  {item?.user_name}
                                </Mui.Stack>
                              ) : (
                                item[head.key]
                              )}
                            </Mui.TableCell>
                          )
                        )}
                      </Mui.TableRow>
                      {expendRowId === item.id && (
                        <Mui.TableRow>
                          <Mui.TableCell colSpan={12}>
                            <Mui.TableContainer
                              sx={{
                                marginTop: 0,
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "100%px",
                              }}
                              className="w-96 border rounded"
                            >
                              <Mui.Table>
                                <Mui.TableHead
                                  sx={{
                                    backgroundColor: themes.primary,
                                  }}
                                >
                                  <Mui.TableRow
                                    sx={{
                                      "& .MuiTableCell-root": {
                                        height: "6px",
                                        padding: "6px 10px",
                                      },
                                    }}
                                  >
                                    {individualLeaveGroupDetails.map((head) => (
                                      <Mui.TableCell
                                        sx={{
                                          color: themes.headLine,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {head.name}
                                      </Mui.TableCell>
                                    ))}
                                  </Mui.TableRow>
                                </Mui.TableHead>
                                <Mui.TableBody>
                                  {individualLoader ? (
                                    <Mui.TableRow sx={tableRowSx}>
                                      <Mui.TableCell
                                        colSpan={10}
                                        style={{
                                          textAlign: "center",
                                          // height: "20vh",
                                        }}
                                      >
                                        <Mui.Grid
                                          container
                                          justifyContent="center"
                                        >
                                          <Mui.Box
                                            sx={{
                                              position: "relative",
                                              display: "inline-flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: 100,
                                              height: 100,
                                            }}
                                          >
                                            <Mui.CircularProgress
                                              size={70}
                                              thickness={2}
                                              sx={{
                                                color: themes.primaryIndicator,
                                              }}
                                            />

                                            <Mui.Box
                                              sx={{
                                                position: "absolute",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: 40,
                                                height: 40,
                                              }}
                                            >
                                              <img
                                                src={comLogo}
                                                alt="Company Logo"
                                                style={{
                                                  width: "100%",
                                                  height: "100%",
                                                  objectFit: "contain",
                                                }}
                                              />
                                            </Mui.Box>
                                          </Mui.Box>
                                        </Mui.Grid>
                                      </Mui.TableCell>
                                    </Mui.TableRow>
                                  ) : expandDetails.length === 0 &&
                                    !individualLoader ? (
                                    <Mui.TableRow
                                      maxWidth="xl"
                                      align="left"
                                      sx={tableRowSx}
                                    >
                                      <Mui.TableCell colSpan={12}>
                                        <Mui.Alert
                                          sx={{ marginTop: 3 }}
                                          severity="info"
                                        >
                                          No data available
                                        </Mui.Alert>
                                      </Mui.TableCell>
                                    </Mui.TableRow>
                                  ) : (
                                    expandDetails?.map((detail) => (
                                      <Mui.TableRow
                                        sx={{
                                          "& .MuiTableCell-root": {
                                            height: "10px",
                                            padding: "10px 10px",
                                          },
                                        }}
                                      >
                                        {individualLeaveGroupDetails?.map(
                                          (head) => (
                                            <Mui.TableCell>
                                              {detail[head.key] ||
                                              detail[head.key] === 0
                                                ? detail[head.key]
                                                : "N/A"}
                                            </Mui.TableCell>
                                          )
                                        )}
                                      </Mui.TableRow>
                                    ))
                                  )}
                                </Mui.TableBody>
                              </Mui.Table>
                            </Mui.TableContainer>
                          </Mui.TableCell>
                        </Mui.TableRow>
                      )}
                    </>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
      </Mui.Grid>
      {advanceSalaryData?.length > 25 ? (
        <Mui.TablePagination
          className="custom-pagination"
          component="div"
          rowsPerPageOptions={[25, 50, 75, 100]}
          count={advanceSalaryData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : null}
      {selectedArray?.length > 0 && (
        <Mui.Grid
          sx={{
            mt: 1,
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: 3,
          }}
        >
          <CustomButton
            actionName="Next"
            typeName="button"
            actionFuntion={() => {
              if (
                checkEditorPermission(
                  userScreenAccess?.module_details,
                  "LMS",
                  "Assignment"
                )
              ) {
                setShowCreditDetils(true);
              } else {
                showToast(
                  "error",
                  "Access denied: You are not authorized to allow move the user"
                );
              }
            }}
          />
        </Mui.Grid>
      )}
      {individualPersonMove ? (
        <IndividualLeaveGroupMove
          individualPersonMove={individualPersonMove}
          setIndividualPersonMove={setIndividualPersonMove}
          individualPersonMoveDetails={individualPersonMoveDetails}
          setFetchUserDetails={setFetchUserDetails}
        />
      ) : null}
    </React.Fragment>
  );
};
